export function resolveUserFirstName(name: string | null | undefined): string | null {
  const trimmed = name?.trim();
  if (!trimmed) {
    return null;
  }

  const [firstName] = trimmed.split(/\s+/);
  return firstName || null;
}
